import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";
import type { ICountdownTimerTheme } from "app/components/timers/CountdownTimer/StyledCountdownTimer";
import styled from "styled-components";

export const SEASONAL_CAMPAIGN_MODAL_STYLE: ReactModal.Styles = {
    content: {
        width: 434,
        background: `radial-gradient(98.49% 98.49% at 50% 1.51%, #435993 0%, #0E1C48 58.65%)`,
        border: 0,
    },
};

export const SEASONAL_CAMPAIGN_TIMER_THEME: ICountdownTimerTheme = {
    timeBoxWrapperBorderColor: colorsPalettes.carbon[0],
    timeBoxWrapperBackground: `linear-gradient(206deg, ${colorsPalettes.carbon[0]} -155.94%, rgba(255, 255, 255, 0.00) 135.15%)`,
    timeValueColor: colorsPalettes.carbon[0],
    timeLabelColor: colorsPalettes.carbon[0],
    withLabel: true,
};

export const LimitedTimeOffer = styled(Text)`
    border-radius: 4px;
    border: 0.6px solid ${colorsPalettes.midnight[200]};
    background: linear-gradient(206deg, rgba(255, 255, 255, 0.30) -155.94%, rgba(255, 255, 255, 0.00) 135.15%);
    backdrop-filter: blur(21.65px);
    width: fit-content;
    padding: 4px 8px;
    color: ${colorsPalettes.midnight[50]};
`;

export const SeasonalCampaignModalContent = styled(Flex)`
    width: 100%;
    height: 100%;
    padding: 36px 16px 40px 16px;
    gap: 24px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: ${colorsPalettes.midnight[50]};
    text-align: center;
`;

export const DiscountText = styled(Text)`
    /* I know usually we don't change the size, but this is a marketing text and
       the discount should be as big as we can get away with */
    font-size: 118px;
    font-weight: 900;
    height: 87px;
    line-height: 88px;

    background: linear-gradient(29deg, #FFB800 0%, #FFB103 29.36%, #FF9F0A 70.2%, #FF8117 118.7%, #FF7A1A 127.64%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const PercentText = styled(Text)`
    /* Same here */
    font-size: 76px;
    height: 52px;
`;
